import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faDollarSign, faHashtag, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        movement_month: '',
        movement_date: '',
        initial_balance: '',
        errors: [],
    }
    sessionExpired = () => {
        Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
        window.localStorage.clear();
        window.location.href = '/';
    }
    changeValue = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errors: [] })
    }
    errorVerify(element) {
        return this.state.errors.indexOf(element) !== -1;
    }
    sendData = async (e) => {
        e.preventDefault();
        const { movement_month, movement_date, initial_balance } = this.state;
        var errors = [];
        if (!movement_month) { errors.push("error_movement_month"); }
        if (!movement_date) { errors.push("error_movement_date"); }
        if (!initial_balance) { errors.push("error_initial_balance"); }
        console.log(errors.length);
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        var data = {
            movement_year: movement_month.substring(0, 4),
            movement_month: movement_month.substring(5),
            movement_date: movement_date,
            initial_balance: initial_balance,
            user_id: window.localStorage.getItem('idusuario')
        }
        try {
            Swal.fire({
                title: 'Guardando...',
                text: 'Por favor, Espere',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            const movementsDataRes = await authAxios.post("movements/register", data);
            if (!movementsDataRes.data.status) {
                this.sessionExpired();
                return;
            }
            Swal.close();
            Swal.fire(
                'Movimientos!',
                movementsDataRes.data.msj,
                'success'
            );
            this.props.history.push("/UpMovements/" + movementsDataRes.data.ID_MOVEMENT);
        } catch (error) {
            console.error(error);
            Swal.close();
        }
    }
    componentDidMount() {
        Swal.showLoading();
        Swal.close();
    }
    render() {
        const { movement_month, movement_date, initial_balance } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>NUEVO MOVIMIENTO</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.sendData}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <hr style={{ marginBottom: 0, marginTop: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN MOVIMIENTO</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="movement_month">Mes Movimiento</label>
                                                    <div className={((this.errorVerify("error_movement_month")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="month" name="movement_month" id="movement_month" value={movement_month}
                                                            className={((this.errorVerify("error_movement_month")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Mes Movimiento" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Mes Movimiento</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="movement_date">Fecha Movimiento</label>
                                                    <div className={((this.errorVerify("error_movement_date")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="movement_date" id="movement_date" value={movement_date}
                                                            className={((this.errorVerify("error_movement_date")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Fecha Movimiento" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Movimiento</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="initial_balance">Balance Inicial</label>
                                                    <div className={((this.errorVerify("error_initial_balance")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="initial_balance" id="initial_balance" value={initial_balance}
                                                            className={((this.errorVerify("error_initial_balance")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Balance Inicial" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Balance Inicial</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Guardar</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterMovements"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;